export interface ParticipationRateSearchCriteria {
    etdFrom: Date | null,
    etdTo: Date | null,
    co: string | null,
    vsl: string | null,
    voy: string | null,
    soa: string | null,
    activeInd: string | null,

    [key: string]: string | number | Date | null | undefined
}

export const EMPTY_PARTICIPATION_RATE_SEARCH_CRITERIA: ParticipationRateSearchCriteria = {
    etdFrom: null,
    etdTo: null,
    co: null,
    vsl: null,
    voy: null,
    soa: null,
    activeInd: null
}

